const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;
const DAYS_PER_YEAR = 365;
const DAYS_PER_MONTH = 30;
const DAYS_WITH_HOURS_LIMIT = 7;

export function formatAssignmentDuration(startMs: number, endMs: number): string {
  const elapsedMs = Math.max(0, endMs - startMs);
  if (elapsedMs < HOUR_MS) {
    return '<1h';
  }

  const totalHours = Math.floor(elapsedMs / HOUR_MS);
  if (elapsedMs < DAY_MS) {
    return `${totalHours}h`;
  }

  const totalDays = Math.floor(elapsedMs / DAY_MS);
  if (totalDays >= DAYS_PER_YEAR) {
    const years = Math.floor(totalDays / DAYS_PER_YEAR);
    const months = Math.floor((totalDays % DAYS_PER_YEAR) / DAYS_PER_MONTH);
    return months ? `${years}y ${months}m` : `${years}y`;
  }

  const hours = totalHours % 24;
  return totalDays < DAYS_WITH_HOURS_LIMIT && hours ? `${totalDays}d ${hours}h` : `${totalDays}d`;
}
